import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_PROGRESS_CONDITION } from "../../../utils/globalConstantUtil";
import { createLikeCondition } from "../../../utils/bukken/helpers/handlePayloadBukkenSearch";

const initialState = Object.freeze({
  bukkenName: "",
  bukkenUuid: "",
  bukkenClassUuid: "",
  patterNameActive: "",
  isOpenDropdown: false,
  // isAddNewBukken: false, 
  progressCondition: INITIAL_PROGRESS_CONDITION,
  classCondition: [],
  locationCondition: [],
  contractCondition: [],
  pageActive: 1,
  pageActivePhotobook: 1,
  payloadBukkenSearch: {
    info: {
      progress: INITIAL_PROGRESS_CONDITION.map(createLikeCondition)
    }
  },
  listBukken: [],
  isSearchMode: true,
  payloadSearchFolderFile: {},
  isSearchFolderFileMode: false,
  blackboardMstActive: {},
  infoSearchExpanded: {},
  // Store progress selections keyed by search_key (e.g. basic_info_uuid)
  progressByKey: []
});

export const stateBukkenSlice = createSlice({
  name: "stateBukken",
  initialState,
  reducers: {
    setBukkenClassUuid: (state, action) => {
      state.bukkenClassUuid = action.payload;
    },
    setIsOpenDropdown: (state) => {
      state.isOpenDropdown = !state.isOpenDropdown;
    },
    setBukkenUuid: (state, action) => {
      state.bukkenUuid = action.payload;
    },
    setBukkenName: (state, action) => {
      state.bukkenName = action.payload;
    },
    setPatternActive: (state, action) => {
      state.patterNameActive = action.payload;
    },
    // setAddNewItem: (state, action) => {
    //   state.isAddNewBukken = action.payload;
    // },
    setProgressCondition: (state, action) => {
      state.progressCondition = action.payload;
    },
    setPageActive: (state, action) => {
      state.pageActive = action.payload;
    },
    setPayloadBukkenSearchStore: (state, action) => {
      state.payloadBukkenSearch = action.payload;
    },
    setPageActivePhotobook: (state, action) => {
      state.pageActivePhotobook = action.payload;
    },
    setListBukkenStore: (state, action) => {
      state.listBukken = action.payload;
    },
    setIsSearchMode: (state, action) => {
      state.isSearchMode = action.payload;
    },
    setIsSearchFolderFileMode: (state, action) => {
      state.isSearchFolderFileMode = action.payload;
    },
    setPayloadSearchFolderFile: (state, action) => {
      state.payloadSearchFolderFile = action.payload;
    },
    setBlackboardMstActive: (state, action) => {
      state.blackboardMstActive = action.payload;
    },
    setClassCondition: (state, action) => {
      state.classCondition = action.payload;
    },
    setLocationCondition: (state, action) => {
      state.locationCondition = action.payload;
    },
    setContractCondition: (state, action) => {
      state.contractCondition = action.payload;
    },

    setInfoSearchExpanded: (state, action) => {
      state.infoSearchExpanded = action.payload;
    },
    setProgressByKey: (state, action) => {
      state.progressByKey = action.payload;
    },
    resetStateBukken: () => initialState
  }
});

export const {
  setBukkenClassUuid,
  setIsOpenDropdown,
  setBukkenUuid,
  setBukkenName,
  setPatternActive,
  // setAddNewItem, 
  setProgressCondition,
  setPageActive,
  setPayloadBukkenSearchStore,
  setPageActivePhotobook,
  setListBukkenStore,
  setIsSearchMode,
  setIsSearchFolderFileMode,
  setPayloadSearchFolderFile,
  setBlackboardMstActive,
  setClassCondition,
  setLocationCondition,
  setContractCondition,
  setInfoSearchExpanded,
  setProgressByKey,
  resetStateBukken
} = stateBukkenSlice.actions;

export default stateBukkenSlice.reducer;
